import { BrowserRouter, Routes, Route } from 'react-router-dom';

import "bootstrap/scss/bootstrap.scss";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap-icons/font/bootstrap-icons.scss";

import Layout from './containers/Layout';
import PatientsPage from './pages/Patients/PatientsPage';
import PatientDetailPage from './pages/Patients/PatientDetailPage';
import ProfilesPage from './pages/Profiles/ProfilesPage';
import ProfileDetailPage from './pages/Profiles/ProfileDetailPage';
import CalendarPage from './pages/CalendarPage';
import RegistroCitasPage from './pages/RegistroCitasPage';
import MainFinancePage from './pages/Finances/MainFinancePage';
import IngresosPage from './pages/Finances/IngresosPage';
import EgresosPage from './pages/Finances/EgresosPage';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import StatsPage from './pages/StatsPage';
import MyProfile from './pages/Profiles/MyProfile';
import PasswordResetConfirm from './pages/Profiles/PasswordResetConfirm';
import PatientFMSPage from './pages/Patients/PatientFMSPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<AuthPage />} />
        <Route path="/password-reset/confirm/:uid/:token" element={<PasswordResetConfirm />} />
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/pacientes" element={<PatientsPage />} />
          <Route path="/paciente/:pacienteId" element={<PatientDetailPage />} />
          <Route path="/paciente/:pacienteId/fms" element={<PatientFMSPage />} />
          <Route path="/paciente/:pacienteId/listacitas" element={<RegistroCitasPage />} />
          <Route path="/paciente/:pacienteId/listacitas/?serviceId=:serviceId" element={<RegistroCitasPage />} />
          <Route path="/perfiles" element={<ProfilesPage />} />
          <Route path="/perfil/:perfilId" element={<ProfileDetailPage />} />
          <Route path="/perfil/miperfil" element={<MyProfile />} />
          <Route path="/agenda" element={<CalendarPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/mis-finanzas" element={<MainFinancePage />} />
          <Route path="/finanzas" element={<MainFinancePage />} />
          <Route path="/finanzas/ingresos/" element={<IngresosPage />} />
          <Route path="/finanzas/egresos/:tipoEgreso?" element={<EgresosPage />} />
          {/* <Route path="/inventario" element={<h1>Estadisticas</h1>} /> */}
        </Route>
      </Routes>

    </BrowserRouter>
  );
}

export default App;
